import API_URLS from "../../config/BackendConfig";
import { getToken } from "../../utils/tokenUtils";
import { getRequest,postRequest } from "../../config/AxiosConfig";
import axios from "axios";

const prodBaseUrl = API_URLS.PROD;

const apiBaseUrl = API_URLS.CUSTOMER;

const getAuthHeaders = () => {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  };



// Fetch State 
export const fetchStateService = async () => {
    try {
        const response = await postRequest({
            url: apiBaseUrl + "fetch-state",
            headers: getAuthHeaders(),
        })
        return response;
    } catch (error) {
        console.error("error in fetching State", error.response?.data || error.message);
        throw error;
    }
};

  // Equifax PDF
  export const GetEquifaxPDFService = async (payload) => {
    try {
      const response = await postRequest({
        url: `${prodBaseUrl}srv2/credit-report/equifax-pdf`,
        data: payload,
        headers: getAuthHeaders(),
      });
      return response
    } catch (error) {
      return error;
    }
  }

  // Global PDF URL
  export const downloadEquifaxPDF = async (pdfUrl) => {
  try {
    const response = await axios.get(pdfUrl, {
      responseType: 'blob',
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

 // Crif PDF
export const GetCrifPDFService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/crif-pdf`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response
  } catch (error) {
    
  }
}




export const downloadTransunionPDF = async (pdfUrl) => {
  try {
    const response = await axios.get(pdfUrl, {
      responseType: "blob",
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getExperianPdf = async ({
  api_key,
  api_id,
  token_id,
  pan,
  mobile,
  gender,
  name,
  state,
  dob,
  address,
  pincode,
  consent,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    pan,
    mobile,
    gender,
    name,
    state,
    dob,
    address,
    pincode,
    consent,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/experian-pdf`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};



export const getTransunionPdf = async ({
api_key,
api_id,
token_id,
pan,
mobile,
gender,
name,
consent,
}) => {
const payload = {
api_id,
api_key,
token_id,
pan,
mobile,
gender,
name,
consent,
};

try {
const response = await postRequest({
url: `${prodBaseUrl}srv2/credit-report/transunion-pdf`,
headers: getAuthHeaders(),
data: payload,
});
return response;
} catch (error) {
throw error;
}
};



export const downloadExperianPDF = async (pdfUrl) => {
  try {
    const response = await axios.get(pdfUrl, {
      responseType: "blob",
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
